import { DisplayCard } from '../../../../ui-components';
import { ChartMetrics } from './components/ChartMetrics';

export const BrandPerformanceChart = () => {
  return (
    <DisplayCard title="Sales Summary">
      <DisplayCard.Content w={'100%'}>
        <ChartMetrics />
      </DisplayCard.Content>
    </DisplayCard>
  );
};
